import { Radio } from "antd";
import { useTranslation } from "react-i18next";

const IpgMethod = ({ data, paymentMethod }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`p-5 border border-gray--7 rounded-lg mb-4 bg-white flex justify-between  ${
        paymentMethod === data.value && "border-gray-1"
      }`}
    >
      <Radio
        value={data.value}
        className={`body-16px-regular ${
          paymentMethod === data.value && "body-16px-demibold"
        }`}
      >
        {`${t("bank-portal")} ${data.label}`}
      </Radio>
      <img src={data?.icon} alt="pspicon" />
    </div>
  );
};
export default IpgMethod;
